import { supabase } from './supabaseClient';
import { convertToWebp } from './imageUtils';

const MAX_SIZE_BYTES = 8 * 1024 * 1024;
const ALLOWED_TYPES = ['image/png', 'image/jpeg', 'image/webp', 'image/gif'];
const MAX_DIMENSION = 1600;

// Images embedded inside a custom page's blocks — unlike useSiteImage keys,
// these have no fixed identity/fallback to override, so they just get a
// fresh path in the same rxk-content bucket and the resulting URL is stored
// directly in the block's jsonb.
export async function uploadPageImage(file: File): Promise<string> {
  if (!ALLOWED_TYPES.includes(file.type)) {
    throw new Error('Please choose a PNG, JPEG, WEBP, or GIF image.');
  }
  if (file.size > MAX_SIZE_BYTES) {
    throw new Error('Image must be smaller than 8MB.');
  }

  const webp = await convertToWebp(file, MAX_DIMENSION);
  const path = `pages/${Date.now()}-${Math.random().toString(36).slice(2, 8)}.webp`;

  const { error: uploadError } = await supabase.storage.from('rxk-content').upload(path, webp, {
    contentType: 'image/webp',
  });
  if (uploadError) throw uploadError;

  const {
    data: { publicUrl },
  } = supabase.storage.from('rxk-content').getPublicUrl(path);

  return publicUrl;
}

export function slugify(text: string): string {
  return text
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 80);
}
